<mat-card class="custom-mat-card">
  <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="10px">
    <div style="min-width:100px;">
      <app-workflow-status
        [status]="data.requestStatusId"
        [qrCode]="data.qrCode"></app-workflow-status>
    </div>
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between" style="cursor: pointer;" fxLayoutGap="10px"
      (click)="onRequestDetails(data.id)">
      <div fxLayout="column" fxLayoutGap="10px" class="custom-padding">
        <div fxLayout="column" fxLayoutGap="8px">
          <span class="textsmaller regular">RQ-ID {{ data.id }}</span>
          <span *ngIf="isApproval" class="textLarge regular" ngClass.xs="textsmall regular"> {{data.name}} </span>
          <span *ngIf="!isApproval" class="textLarge regular" ngClass.xs="textsmall regular"> {{data.facilityName}}
          </span>
          <span fxHide.xs="false" fxHide="true" *ngIf="isApproval" ngClass.xs="textsmall regular"
            class="textLarge regular">{{data.facilityName}}</span>
        </div>
        <div>
          <span class="textsmalllight regular">{{data.siteRequestDuration.startDate | date:'d MMMM yy' }} -
            {{data.siteRequestDuration.endDate | date:'d MMMM yy'}}</span>
        </div>
      </div>
      <div fxLayout="column" *ngIf="!isApproval" fxLayoutAlign="center center" class="custom-padding">
        <img alt="img" src="assets/icons/arrow.svg" class="img-arrow" />
      </div>
      <div fxLayout="column" fxHide.xs="false" fxHide="true" *ngIf="isApproval" fxLayoutAlign="center center"
        class="custom-padding">
        <img alt="img" src="assets/icons/arrow.svg" class="img-arrow" />
      </div>
      <div fxLayout="column" fxHide.xs="true" *ngIf="isApproval" fxLayoutAlign="space-between end"
        class="custom-padding">
        <span *ngIf="isApproval" class="textLarge regular"> {{data.facilityName}} </span>
        <span fxLayout="row" fxLayoutAlign="end end">
          <img alt="img" src="assets/icons/arrow.svg" class="img-arrow" style="padding-bottom: 5px;" />
        </span>
      </div>
    </div>

  </div>
</mat-card>
